module.exports = __webpack_public_path__ + "static/media/miniOverbox.f3a25a8c.png";